import React, { useEffect } from "react";
import { connect } from "react-redux";
import { getGradeList } from "../../actions/Grade.action";
import ViewRangedWeeklyFiles from "../../components/ViewRangedWeeklyFiles/ViewRangedWeeklyFiles";
import Layout from "../../components/shared/Layout/Layout";

const ViewRangedWeeklyFilePage = ({ grades, getGradeList }) => {
  useEffect(() => {
    getGradeList();
  }, []);
  return (
    <div className="bg_light">
      <Layout title={`Ranged Weekly Assessment`}>
        <ViewRangedWeeklyFiles grades={grades} />
      </Layout>
    </div>
  );
};

const mapStateToProps = (state) => ({
  grades: state.grade.grade,
});

export default connect(mapStateToProps, { getGradeList })(
  ViewRangedWeeklyFilePage
);
